if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');


          // ✅ Slide main Flickity to this media
          if (window.mainFlickity) {
            const flkty = window.mainFlickity;
            const cells = flkty.cells.map(c => c.element);
            let index = -1;

            // Find which Flickity cell contains this active media
            for (let i = 0; i < cells.length; i++) {
              if (cells[i] === activeMedia || cells[i].contains(activeMedia)) {
                index = i;
                break;
              }
            }

            if (index > -1) {
              flkty.select(index);
              console.log("✅ Flickity slide moved to index:", index);
            } else {
              console.warn("⚠️ Active media not found in Flickity cells");
            }
          }

        //activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if(!container)return;

        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
